import { render, staticRenderFns } from "./buscarExpedienteGen.vue?vue&type=template&id=197f8173"
import script from "./buscarExpedienteGen.vue?vue&type=script&lang=js"
export * from "./buscarExpedienteGen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports